import {
  createSigmaIntegrationAsync,
  deleteSigmaIntegrationAsync,
  getAllSigmaIntegrationsAsync,
  getSigmaAccountsAsync,
  getSigmaIntegrationByIdAsync,
  updateSigmaIntegrationAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSigmaIntegrationAsync = () =>
  useMutation(createSigmaIntegrationAsync);

export const useGetSigmaIntegrationByIdAsync = () =>
  useMutation(getSigmaIntegrationByIdAsync);

export const useGetAllSigmaIntegrationsAsync = () =>
  useMutation(getAllSigmaIntegrationsAsync);

export const useUpdateSigmaIntegrationAsync = () =>
  useMutation(updateSigmaIntegrationAsync);

export const useDeleteSigmaIntegrationAsync = () =>
  useMutation(deleteSigmaIntegrationAsync);

export const useGetSigmaAccountsAsync = () =>
  useMutation(getSigmaAccountsAsync);
